import React from 'react'

import CompetitiveIntelligenceOverview from 'components/CompetitiveIntelligence/Overview'
import CompetitiveIntelligenceSkeleton from 'components/CompetitiveIntelligence/Skeleton'
import CompetitiveIntelligenceState from 'components/CompetitiveIntelligence/State'
import CompetitiveIntelligenceNavigation from 'components/CompetitiveIntelligence/Navigation'
import useController from './controller'
import { Freshness, Operations, Page, SyncButton, SyncFeedback } from './styled'

const STATE_COPY = {
    denied: ['competitive_intelligence_denied_title', 'competitive_intelligence_denied_description'],
    empty: ['competitive_intelligence_empty_title', 'competitive_intelligence_empty_description'],
    error: ['competitive_intelligence_error_title', 'competitive_intelligence_error_description'],
    unavailable: ['competitive_intelligence_unavailable_title', 'competitive_intelligence_unavailable_description'],
}

export default function CompetitiveIntelligence() {
    const { canSync, formatDate, overview, retry, status, sync, syncStatus, t } = useController()
    const copy = STATE_COPY[status]
    const syncCopy = syncStatus === 'started'
        ? t('competitive_intelligence_sync_started')
        : syncStatus === 'error'
            ? t('competitive_intelligence_sync_failed')
            : null

    return (
        <Page>
            <CompetitiveIntelligenceNavigation landing t={t} />

            {['ready', 'empty'].includes(status) ? (
                <Operations aria-label={t('competitive_intelligence_operations')}>
                    <Freshness>
                        {t('last_updated')}: {formatDate(overview?.lastUpdatedAt)}
                    </Freshness>
                    {syncCopy ? (
                        <SyncFeedback $error={syncStatus === 'error'} role="status">
                            {syncCopy}
                        </SyncFeedback>
                    ) : null}
                    {canSync ? (
                        <SyncButton
                            $syncing={syncStatus === 'syncing'}
                            aria-label={t('competitive_intelligence_sync_hint')}
                            disabled={syncStatus === 'syncing' || syncStatus === 'started'}
                            onClick={sync}
                            title={t('competitive_intelligence_sync_hint')}
                            type="button"
                        >
                            <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
                                <path d="M20 7v5h-5M4 17v-5h5M6.1 9A7 7 0 0 1 18.3 6.3L20 8M4 16l1.7 1.7A7 7 0 0 0 17.9 15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
                            </svg>
                            {syncStatus === 'syncing'
                                ? t('competitive_intelligence_syncing')
                                : t('competitive_intelligence_sync')}
                        </SyncButton>
                    ) : null}
                </Operations>
            ) : null}

            {status === 'loading' ? (
                <CompetitiveIntelligenceSkeleton label={t('competitive_intelligence_loading')} />
            ) : status === 'ready' ? (
                <CompetitiveIntelligenceOverview t={t} />
            ) : copy ? (
                <CompetitiveIntelligenceState
                    actionLabel={t('try_again')}
                    description={t(copy[1])}
                    onAction={['error', 'unavailable'].includes(status) ? retry : undefined}
                    title={t(copy[0])}
                    urgent={['denied', 'error', 'unavailable'].includes(status)}
                />
            ) : null}
        </Page>
    )
}
